import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import PortalUsersVM from './PortalUsersVM';
import { observer } from 'mobx-react';
import { ModalUtils } from '@singularsystems/neo-core';
import * as Roles from "../../Models/Security/Roles";
import PortalUsersEditModal from './PortalUsersEditModal';
import AuthoriseButton from "../../Components/AuthoriseButton";
import AuthorisationComponents from "../../Components/AuthorisationComponents";
import PortalUser from "../../Models/PortalUser/PortalUser";

class PortalUsersParams {
}

@observer
export default class PortalUsersView extends Views.ViewBase<PortalUsersVM, PortalUsersParams> {
    public static params = new PortalUsersParams();

    constructor(props: unknown) {
        super("Portal Users", PortalUsersVM, props);
    }

    public render() {
        const canAdd = this.viewModel.authorisationService.hasRole(Roles.PortalUsersAdmin.Edit);
        return (
            <div>
                <Neo.Card title="Criteria">
                    <div className="row">
                        <Neo.FormGroupInline bind={this.viewModel.criteria.meta.firstName} className="col-lg-4" />
                        <Neo.FormGroupInline bind={this.viewModel.criteria.meta.lastName} className="col-lg-4" />
                        <Neo.FormGroupInline bind={this.viewModel.criteria.meta.loginName} className="col-lg-4" />
                    </div>
                </Neo.Card>
                <Neo.Card title={"Portal Users"}>
                    <Neo.Pager pageManager={this.viewModel.pageManager} pageControls="bottom" >
                        <NeoGrid.Grid<PortalUser> addButton={canAdd ? { onClick: () => this.viewModel.editPortalUser(null) } : undefined}>
                            {(item, meta) => (
                                <NeoGrid.Row>
                                    <NeoGrid.Column display={meta.firstName} />
                                    <NeoGrid.Column display={meta.lastName} />
                                    <NeoGrid.Column display={meta.loginName} />
                                    <NeoGrid.Column display={item.lookup.meta.emailAddress}>
                                        {!item.contactId && <Neo.Badge variant="warning">No contact details</Neo.Badge>}
                                    </NeoGrid.Column>
                                    <NeoGrid.Column display={meta.isAdminPortal} label="Admin User?" />
                                    <NeoGrid.Column display={meta.userGroupId}
                                        select={{ itemSource: this.viewModel.authorisationDataCache.userGroups, displayMember: "userGroupName", renderAsText: true }}>
                                        {!item.userGroupId && <Neo.Badge variant="warning">No User Group</Neo.Badge>}
                                    </NeoGrid.Column>
                                    <NeoGrid.Column display={item.authorisation.meta.isAuthorised} label="Authorised?" />
                                    <NeoGrid.Column display={meta.isActive} />
                                    {this.viewModel.pageManager.data.some(c => !c.authorisation.isAuthorised) &&
                                        <NeoGrid.ButtonColumn>
                                            <AuthoriseButton
                                                className="me-2"
                                                viewModel={this.viewModel.authorisationVM}
                                                currentRecord={item}
                                                preAuthoriseRoleName={""}
                                                authoriseRoleName={item.isAdminPortal ? Roles.PortalUsersAdmin.Authorise : Roles.PortalUsersClient.Authorise}
                                                onDelete={() => {
                                                    this.viewModel.pageManager.refreshData(true);
                                                }} />
                                        </NeoGrid.ButtonColumn>}
                                    <NeoGrid.ButtonColumn
                                        editButton={{ onClick: () => this.viewModel.editPortalUser(item), disabled: !this.hasRole(item.isAdminPortal, Roles.PortalUsersAdmin.Edit, Roles.PortalUsersClient.Edit) }}
                                        deleteButton={{
                                            onClick: () => {
                                                this.viewModel.setPendingDelete(item);
                                            },
                                            disabled: !this.hasRole(item.isAdminPortal, Roles.PortalUsersAdmin.Delete, Roles.PortalUsersClient.Delete),
                                            icon: item.isPendingDelete ? "trash-restore" : "trash",
                                            tooltip: item.isPendingDelete ? "Stop the portal user from being removed when authorised."
                                                                          : "Mark the portal user to be removed when authorised."
                                        }} />
                                </NeoGrid.Row>
                            )}
                        </NeoGrid.Grid>
                    </Neo.Pager>
                </Neo.Card>

                <PortalUsersEditModal viewModel={this.viewModel} />
                <AuthorisationComponents viewModel={this.viewModel.authorisationVM} />
            </div>
        );
    }

    private hasRole(isAdmin: boolean, adminRole: string, clientRole: string) {
        if (isAdmin) {
            return this.viewModel.authorisationService.hasRole(adminRole);
        } else {
            return this.viewModel.authorisationService.hasRole(clientRole);
        }
    }
}